module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=VG - British Virgin Islands.224a683b.svg";